export default "__VITE_ASSET__DO$PBUex__"